import { Box } from '@mui/system';

import { GuardianRulesTable } from './GuardianRulesTable';
import { OrgPolicyResults } from './types/ApplicationDetailsType';

interface IProps {
  analysisId: string;
  data: object;
  customRules?: object;
  highRiskCountries?: string[];
  refresh?: () => void;
  filterSection?: 'overview' | 'permission' | 'behaviors' | 'malicious' | '';
  policyViolations?: OrgPolicyResults[];
}

export const FiltersAndTable = ({ analysisId, data, customRules, highRiskCountries, policyViolations, refresh, filterSection }: IProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', minHeight: '100vh' }}>
      <Box
        sx={{
          overflowY: 'auto',
        }}
      >
        <GuardianRulesTable
          data={data}
          analysisId={analysisId}
          customRules={customRules}
          highRiskCountries={highRiskCountries}
          policyViolations={policyViolations}
          refresh={refresh}
          filterSection={filterSection}
        />
      </Box>
    </Box>
  );
};
